/**
 * ACCOUNT-LOGO
 * Logo of an account in the supervisor benchmark lists, or a neutral building icon when it has none
 * (hasImage comes from the accounts list, so no request is made for a logo that does not exist).
 * Always the same square slot so names stay aligned from row to row.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBuilding } from "@fortawesome/free-solid-svg-icons"
import { useAppSelector } from "@/core/root-reducer"
import { getImageUrl } from "@/utils/get-image-url"

interface Props {
  id: string
  hasImage: boolean
  size?: number
}

export default function AccountLogo({ id, hasImage, size = 28 }: Props) {
  const logoLastUpdate = useAppSelector((state) => state._session.logoLastUpdate)

  return (
    <span className="flex items-center justify-center grey-t" style={{ width: size, height: size, flexShrink: 0 }}>
      {hasImage ? (
        <img
          alt=""
          src={getImageUrl("Accounts", id, logoLastUpdate)}
          style={{ width: size, height: size, objectFit: "contain", borderRadius: 4 }}
        />
      ) : (
        <FontAwesomeIcon icon={faBuilding} fixedWidth />
      )}
    </span>
  )
}
